<template>
  <router-link to="team" id="team">
    <video playsinline autoplay muted loop id="video">
      <source src="@/assets/vid/home/TM-SCTN.mp4" type="video/mp4" />
    </video>
    <section class="TeamSection s1">
      <div class="team-text">
        <h2>oc·u·lar | /ˈɒkjʊlə/</h2>
        <br />
        <em>adjective</em>
        <p>hie beschribig ine wenns git...</p>
        <router-link class="team-btn" to="team"
          ><button class="btn-big btn-white">wimr heisse uso</button></router-link
        >
      </div>
    </section>
  </router-link>
</template>

<script>
export default {
  name: "TeamSection",
};
</script>

<style lang="scss" scoped>
#team {
  text-decoration: none;
  z-index: 1;
  #video {
    width: 100%;
    height: 70vh;
    left: 0;
    position: absolute;
    object-fit: cover;
    object-position: center;
    z-index: -1;
  }
  .TeamSection {
    display: flex;
    align-items: center;
    min-height: 70vh;
    padding: 5vw;
    background: transparent;
    background-position: center;
    background-repeat: no-repeat;
    background-size: 100%;
    transition: all 0.3s ease-in-out;
    -webkit-transition: all 0.3s ease-in-out;
    .team-text {
      display: flex;
      flex-direction: column;
      width: 40vw;
      text-align: left;
      margin-left: 40vw;
      h2 {
        text-decoration: none;
        color: #f5f4f3;
        font-family: essonnes-display, serif;
        font-size: 5vw;
      }
      p {
        color: #f5f4f3;
        padding-left: 1vw;
        font-weight: 300;
      }
      em {
        color: #ebebeb;
        font-weight: 200;
        margin-top: -3rem;
      }
    }
    .team-btn {
      padding-top: 3.5rem;
      flex: 1;
    }
  }
}
@media only screen and (max-width: 1024px) {
  #team {
    #video {
      height: 75vh;
    }
    .TeamSection {
      min-height: 75vh;
      .team-text {
        margin-top: 20vw;
        margin-left: 0vw;
        width: 80vw;
        h2 {
          font-size: 10vw;
        }
        p,
        em {
          font-size: 1.8rem;
        }
      }
    }
  }
}
</style>
